<template>
    <div>
        <div class="banner room-bn">
            <img src="@/assets/images/banner10.png" alt="">
            <h2 class="title">期待｜回家的感覺</h2>
        </div>
        <div class="wrap">
            <section id="room-block" class="section">
                <ul class="my_ul_style">
                    <li v-for="room_type in room_types" :key="room_type.id">
                        <router-link :to="{name: 'room', params: {id: room_type.id}}">
                            <span class="my_span_1_style">
                                {{ room_type.room_type }}
                            </span>
                            <span class="my_span_2_style">
                                深入<br>了解
                            </span>
                        </router-link>
                    </li>
                </ul>
            </section>
            <section class="section room-section">
                <div class="room-top">
                    <div class="row">
                        <div class="col col2 left">
                            <div class="row">
                                <div class="col col3-2">
                                    <img :src="imgs_lists[0]" alt="">
                                </div>
                                <div class="col col3" v-if="room_data.appointment_type == 1">
                                    <div class="input-box date">
                                        <select id="visitDate" class="datepicker" v-model="select_date">
                                            <option value="" style="disply:none;" disabled>預約時間</option>
                                            <option v-for="(visit_date, idx) in visit_dates" :key="idx" :value="visit_date">
                                                {{ visit_date }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="input-box">
                                        <select id="visitFloor" v-model="select_floor">
                                            <option value="" style="disply:none;" disabled>樓層選擇</option>
                                            <option v-for="(floor, idx) in visit_floors" :key="idx" :value="floor">
                                                {{ floor }}F
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col col2 right text-center">
                            <h2 class="title">
                                {{ room_data.room_type }}
                            </h2>
                            <div class="icon">
                                <img src="@/assets/images/icon_add.svg" alt="">
                            </div>
                            <p style="white-space: pre-line;">
                                {{ room_data.room_type_content }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="gallery popupGallery">
                    <a v-for="(img_list, idx) in imgs_lists" :key="idx" :href="img_list" class="gallery-item" :style="{backgroundImage: 'url(' + img_list + ')' }"></a>
                </div>
                <div class="intro">
                    <div class="row">
                        <div class="col col2 text-center">
                            <h3 class="title">房間介紹</h3>
                            <div class="content text-left" style="white-space: pre-line;">
                                {{ room_data.room_content }}
                            </div>
                        </div>
                        <div class="col col2 text-center">
                            <h3 class="title">房間價格</h3>
                            <div class="content text-left">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>客房名稱</th>
                                            <th>客房規格</th>
                                            <th>訂價</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(other, idx) in room_others" :key="idx" class="bg-br">
                                            <td align="center" style="border-bottom: 1px solid #111;">
                                                {{ other.room_type }}
                                            </td>
                                            <td align="center" style="border-bottom: 1px solid #111;">
                                                約{{ other.room_ping }}坪<br>
                                                {{ other.room_rooms }}房{{ other.room_bathroom }}衛{{ other.room_parlour }}廳<br>
                                                詳細已房間介紹為主<br>
                                            </td>
                                            <td align="center" style="border-bottom: 1px solid #111;">
                                                <div v-for="(room_price, idx) in JSON.parse(other.room_date_prices)" :key="idx">
                                                    {{room_price}}
                                                </div>
                                                <div>
                                                    長租約
                                                    <br>
                                                    參觀另議
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="ps">
                                    <p>
                                        房價若有變更，以櫃檯公告為準(國定連續假日、暑假、春節)<br>
                                        如遇到連續假日，入住日前14天以前取消訂房，<br>
                                        訂金將全額退還（信用卡方式付訂金扣除$100手續費；匯款方式付訂金扣除$15手續費）；<br>
                                        入住日前14天以後取消訂房，訂金將全額扣款
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-block text-center" v-if="room_data.appointment_type == 1">
                    <a href="javascript:void(0);" class="btn btn-br" @click="send(select_date, select_floor)">
                        確定預約
                    </a>
                </div>
                <div class="btn-block text-center" v-else>
                    <a href="javascript:void(0);" class="btn btn-br">
                        詳情請來電
                    </a>
                </div>
            </section>
        </div>
        <div class="room_model_block" v-show="room_model">
            <div class="model_content">
                <div class="model_content_hed">
                    <p class="text-center">
                        您預約日期:{{select_date}}
                    </p>
                    <p class="text-center">
                        您預約樓層:{{select_floor}}
                    </p>
                </div>
                <div class="model_content_body">
                    <div class="label_box">
                        <label for="user_name">
                            聯絡人姓名:
                            <input name="user_name" v-model="user_name" type="text" placeholder="聯絡人姓名">
                        </label>
                    </div>
                    <div class="label_box">
                        <label for="user_phone">
                            聯絡人電話:
                            <input name="user_phone" v-model="user_phone" type="text" placeholder="聯絡人電話">
                        </label>
                    </div>
                </div>
                <div class="model_content_btn">
                    <button @click="send_push">確定</button>
                    <button @click="room_model = !room_model">取消</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'room',
    data () {
        return {
            room_types: '',
            room_data: '',
            imgs_lists:[],
            room_others: [],
            visit_floors: '',
            visit_dates: '',
            //
            select_date: '',
            select_floor: '',
            user_name: '',
            user_phone: '',
            //
            room_model: false
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'RoomList');
        formData.append('roomtypes_id', this.$route.params.id);
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('RoomList: Server Error');
            } else {
                const get_type = response.data.room_type;
                this.room_types = get_type;
                const get_list = response.data.room_data;
                this.room_data = get_list;
                const get_imgs = response.data.images_url;
                this.imgs_lists = JSON.parse(get_imgs);
                const get_other = response.data.room_type_other;
                this.room_others = get_other;
                
                //預約樓層
                const to_array = JSON.parse(get_list.floor_selection);
                to_array.sort((old,New)=>{
                    return old -New
                });
                this.visit_floors = to_array;
                //預約日期
                const date_to_array = JSON.parse(get_list.appointment_dates);
                date_to_array.sort((old,New)=>{
                    return old -New
                });
                this.visit_dates = date_to_array;
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    methods: {
        get_list (id) {
            const formData = new FormData();
            formData.append('CMD', 'RoomList');
            formData.append('roomtypes_id', id);
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
            .then(response => {
                if (response.data.result == false) {
                    console.log('RoomList: Server Error');
                } else {
                    const get_type = response.data.room_type;
                    this.room_types = get_type;
                    const get_list = response.data.room_data;
                    this.room_data = get_list;
                    const get_imgs = response.data.images_url;
                    this.imgs_lists = JSON.parse(get_imgs);
                    const get_other = response.data.room_type_other;
                    this.room_others = get_other;

                    //預約樓層
                    const to_array = JSON.parse(get_list.floor_selection);
                    to_array.sort((old,New)=>{
                        return old -New
                    })
                    this.visit_floors = to_array;
                    //預約日期
                    const date_to_array = JSON.parse(get_list.appointment_dates);
                    date_to_array.sort((old,New)=>{
                        return old -New
                    });
                    this.visit_dates = date_to_array;
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        send (select_date, select_floor) {
            if (!select_date) {
                alert('請選擇日期');
            } else if (!select_floor) {
                alert('請選擇樓層');
            } else {
                this.room_model = true;
            }
        },
        send_push () {
            if (!this.user_name || !this.user_phone) {
                alert('請輸入聯絡人資訊');
            } else {
                const pushData = new FormData();
                pushData.append('CMD', 'RoomReservation');
                pushData.append('room_type', this.room_data.room_type);
                pushData.append('select_date', this.select_date);
                pushData.append('select_floor', this.select_floor);
                pushData.append('user_name', this.user_name);
                pushData.append('user_phone', this.user_phone);
                this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, pushData)
                .then(response => {
                    console.log(response);
                    if (response.data.result == false) {
                        alert(response.data.error_type);
                    } else {
                        this.room_model = false;
                        this.select_date = '';
                        this.select_floor = '';
                        alert('預約成功');
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            }
        }
    },
    mounted: function() {
        $('.popupGallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true
            }
        });
    },
    watch: {
        $route (e) {
            const goto_page = e.params.id
            this.get_list (goto_page);
        }
    }
};
</script>

<style>
#room-block .my_ul_style{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
#room-block .my_ul_style li{
	flex: 0 0 20%;
	margin: 10px;
}
@media (max-width: 960px) {
	#room-block .my_ul_style li{
		flex: 0 0 40%;
	}
}
@media (max-width: 576px) {
	#room-block .my_ul_style li{
		flex: 1 0 40%;
	}
}
#room-block .my_ul_style li a{
    display: flex;
}
#room-block .my_ul_style li a:hover {
  	color: unset;
}
#room-block .my_ul_style li .my_span_1_style,
#room-block .my_ul_style li .my_span_2_style{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 5px;
}
@media (max-width: 630px) {
    #room-block .my_ul_style li .my_span_1_style,
    #room-block .my_ul_style li .my_span_2_style{
        padding: 10px;
    }
}
#room-block .my_ul_style li .my_span_1_style{
    flex: 3;
	letter-spacing: 5px;
}
#room-block .my_ul_style li .my_span_2_style{
    flex: 1;
    background-color: #b28146;
}
.room_model_block {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}
.room_model_block .model_content{
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.room_model_block .model_content {
    width: 50%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.room_model_block .model_content .model_content_hed,
.room_model_block .model_content .model_content_body,
.room_model_block .model_content .model_content_btn{
    width: 100%;
    background-color: #fff;
    padding: 10px;
}
.room_model_block .model_content .model_content_body{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.room_model_block .model_content .model_content_body .label_box{
    padding: 20px;
}
.model_content_body .label_box input{
    height: 30px;
    font-size: 25px;
}
.room_model_block .model_content .model_content_btn{
    display: flex;
    justify-content: center;
}
.room_model_block .model_content .model_content_btn button{
    padding: 10px 15px;
    margin: 10px;
    background-color: blue;
    color: #fff;
    font-size: 25px;
    border: unset;
    border-radius: 10px;
    box-shadow: -2px 3px 5px #666;
}
.room_model_block .model_content .model_content_btn button:nth-child(2){
    background-color: red;
}
</style>
